import { ControlValueAccessor, Validator, AbstractControl, ValidationErrors } from '@angular/forms';

export abstract class BaseFormField<T = any> implements ControlValueAccessor, Validator {
  value: T;
  disabled = false;
  touched = false;

  protected onChange: (value: T) => void = () => {};
  protected onTouched: () => void = () => {};

  writeValue(value: T): void {
    this.value = value;
  }

  registerOnChange(fn: (value: T) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  markAsTouched(): void {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null; // Puede ser sobreescrito en hijos si se desea validación
  }
}
